
<template>
  <div>
    <div class="cominfo-header">企业中心 <span>/</span><span>培训中心</span><span>/</span><span>试卷管理</span></div>
    <div class="disFlex between curse-search">
      <div>
        <!-- <el-button type="primary" @click="toAdd()">新建试卷</el-button> -->
      </div>
      <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="">
            <el-select v-model="formInline.parentid" placeholder="全部培训类别" clearable>
              <el-option-group v-for="group in options" :key="group.uniqueCode" :label="group.text"
                style="width: 100%;">
                <el-option v-for="item in group.children" :key="item.id" :label="item.text" :value="item.id">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="" style="width: 130px;">
            <el-select v-model="formInline.state" placeholder="请选择状态" clearable>
              <el-option label="启用" value="1"></el-option>
              <el-option label="禁用" value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-loading="loading" style="padding: 10px;background-color: #fff;">
     <el-table :data="tableData.rows" style="width: 100%;margin-bottom: 20px;" row-key="id" border>
        <el-table-column prop="cname" fixed width="350" label="考试标题">
        </el-table-column>
        <el-table-column prop="sjsc" label="考试时长" sortable width="150">
          <template slot-scope="scope">
            {{scope.row.sjsc}}分钟
          </template>
        </el-table-column>
        <el-table-column prop="clevel" label="难度" sortable width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.clevel==1">简单</span>
            <span v-if="scope.row.clevel==2">一般</span>
            <span v-if="scope.row.clevel==3">困难</span>
          </template>
        </el-table-column>
        <el-table-column prop="itype" label="单选题" width="100" sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.itype1Amount&&scope.row.itype1Fraction">
              {{scope.row.itype1Amount}} / {{scope.row.itype1Fraction}}
            </span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="itype" label="多选题" width="100" sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.itype2Amount&&scope.row.itype2Fraction">
              {{scope.row.itype2Amount}} / {{scope.row.itype2Fraction}}
            </span>
            <span v-else>--</span>
          </template>
        </el-table-column>

        <el-table-column prop="itype" label="判断题" width="100" sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.itype3Amount&&scope.row.itype3Fraction">
              {{scope.row.itype3Amount}} / {{scope.row.itype3Fraction}}
            </span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="state" width="100" label="状态">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.state==1">生效</el-tag>
            <el-tag type="info" v-if="scope.row.state==0">未生效</el-tag>
            <el-tag type="danger" v-if="scope.row.state==2">禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createName" label="创建人员" sortable width="150">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" sortable width="150">
        </el-table-column>
        <el-table-column prop="state" fixed="right" width="150" label="操作" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="查看" v-if="scope.row.state==1" placement="top">
              <el-button size="mini" circle type="success" icon="el-icon-view"
                @click="toDetail(scope.row.id,1)"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" v-if="scope.row.state==0" content="编辑" placement="top">
              <el-button size="mini" circle type="primary" icon="el-icon-edit"
                @click="toDetail(scope.row.id,0)"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" v-if="scope.row.state==0" placement="top">
              <el-button size="mini" circle type="primary" icon="el-icon-delete-solid"
                @click="delCurse(scope.row.id)"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="禁用" v-if="scope.row.state==1" placement="top">
              <el-button size="mini" circle type="danger" icon="el-icon-lock"
                @click="changeState(scope.row.id,2)"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="启用"  v-if="scope.row.state==2" placement="top">
                <el-button size="mini" circle type="warning" icon="el-icon-unlock"
                  @click="changeState(scope.row.id,1)"></el-button>
             </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px;text-align: right;" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page="formInline.page" :page-sizes="[10, 20, 30, 50]"
        :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper" :total="tableData.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import BaomingList from '../common/BaomingList';
  export default {
    props: ['collapse', 'wjSrc', 'zyjnList', 'zyzclist', 'currentUser'],
    data() {
      return {
        formInline: {
          parentid: '',
          page: 1,
          rows: 10,
          itype: '',
          cid: ''
        },
        tableData: {
          rows: [],
          total: 0
        },
        options: [{
            text: '专业职称',
            uniqueCode: 'ZXKT_producttype_2',
            children: []
          },
          {
            text: '专业技能',
            uniqueCode: 'ZXKT_producttype_3',
            children: []
          }
        ],
        loading: true
      }
    },
    methods: {
      getcurseList: function() {
        this.loading = true;
        this.$set(this.formInline, 'cid', this.currentUser.cid);
        this.$axios.get('/kt/ktPapersSet/getlistPage.htm?' + this.$qs.stringify(this.formInline), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (data.stat == '0') {
            this.$message.error(data.message);
          } else {
            this.tableData = data;
          }
          this.loading = false;
        })
      },
      toAdd: function() {
        this.$router.push('/Company/Addexam');
      },
      toEdit: function(id) {
        this.$router.push('/Company/Addexam?id=' + id);
      },
      toDetail: function(id,isck) {
        this.$router.push('/Company/Addexam?id=' + id + '&isck='+isck);
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
      delCurse: function(id) {
        var $this = this;
        this.$confirm('您确定要删除该试题吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$axios.post('/kt/ktPapersSet/allocation.htm', this.$qs.stringify({id:id})).then(res => {
          //   var data = res.data;
          //   if (data.stat == '1') {
          //     this.$message({
          //       message: data.message,
          //       type: 'success',
          //       onClose: function() {
          //         $this.getcurseList(1)
          //       }
          //     });
          //   } else {
          //     this.$message.error(data.message);
          //   }
          // })
        }).catch(() => {});
      },
      changeState:function(id,state){
        var text=state==1?'启用':'禁用';
        var $this=this;
        this.$confirm('您确定要'+text+'该试题吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.get('/kt/ktPapersSet/updateStatus.htm?state='+state+'&id=' + id).then(res => {
            var data = res.data;
            if (data.stat == '1') {
              this.$message({
                message: data.message,
                type: 'success'
              });
              $this.getcurseList(1)
            } else {
              this.$message.error(data.message);
            }
          })
        }).catch(() => {});
      }
    },
    created: function() {
      this.$set(this.formInline, 'cid', this.currentUser.orgId)
      this.options[0].children = JSON.parse(localStorage.getItem('zyzcList'));
      this.options[1].children = JSON.parse(localStorage.getItem('zyjnList'));
    },
    components: {
      BaomingList
    },
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getcurseList(1)
        },
        deep: true //true 深度监听
      }
    }
  }
</script>

<style>
  .curse-search {
    padding: 20px;
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin: 20px auto;
  }

  .curse-search .el-form-item {
    margin-bottom: 0;
  }

  .curseInfoBlock {
    width: 256px;
    height: 256px;
    opacity: 1;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.10);
    margin: 0 20px 20px 0;
  }

  .curseevery-title {
    width: 236px;
    height: 40px;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 20px;
    margin: 8px auto;
  }

  .curseevery-title span {
    width: 34px;
    height: 16px;
    opacity: 1;
    background: linear-gradient(126deg, #ff7254 11%, #ff1515 90%);
    border-radius: 6px 6px 6px 0px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.05);
    color: #fff;
    font-size: 12px;
    display: inline-block;
    line-height: 16px;
    text-align: center;
    margin-right: 2px;
  }

  .curseevery-bot {
    width: 256px;
    height: 43px;
    opacity: 1;
    background: #fbfbfc;
    border-top: 1px solid #efefef;
    align-items: center;
    color: #9a9a9a;
    font-size: 13px;
    cursor: pointer;

  }

  .curseevery-bot img {
    margin-right: 4px;
  }

  .curseevery-top {
    position: relative;
  }

  .curseevery-top.ygq::after {
    content: "";
    content: '';
    display: block;
    width: 46px;
    height: 46px;
    background: url(../../assets/images/ygq.png) no-repeat;
    background-size: 46px 46px;
    position: absolute;
    right: 0;
    top: -1px;
  }

  .delVurse {
    position: absolute;
    width: 100%;
    height: 100%;
    display: none;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    align-items: center;
    justify-content: center;
    transition: all 0.3s linear;
  }

  .delVurse span {
    cursor: pointer;
    font-size: 14px;
    color: #ff1515;
  }

  .curseevery-top:hover .delVurse {
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/Examination.vue